import React, { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions, keepSpaceTogether } from '../../../../models/Utils';
import { useMediaQuery } from 'react-responsive';
import { ADAARIARoles } from '../../../../models/ADA';

import './DataGrid.scss';


import AnimatedNumbers from '../AnimatedNumbers/AnimatedNumbers';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import { ChartBox } from '../Charts/ChartBox';
import { LearnMoreButton } from '../LearnMore/LearnMoreButton';

const togetherString = 'V Team';
const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const DataGrid = React.forwardRef((props, theRef) => {
  const [ isMobileLayout, setIsMobileLayout ] = useState(false);
  const refIsMobileLayout = useRef(isMobileLayout);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const boxRefs = props.data.Boxes.map((box) => useRef(null));

  const handleScroll = () => {
    
  };

  const handleResize = () => {
    const viewport = getViewportDimensions();
    const onMobile = viewport.width <= mobileScreenThreshold;
    setIsMobileLayout(onMobile);
    refIsMobileLayout.current = onMobile;
    if (onMobile) {
      // boxRefs.forEach((boxRef) => {
      //   const parentNode = boxRef.current.parentNode
      //   const width = parentNode.getBoundingClientRect().width;
      //   const chart = 
      // });
    }
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);
    document.body.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const getCells = (inputBoxes, onMobile) => {
    let items = [];
    const boxes = [ ...inputBoxes ];
    const sumOfBoxes = boxes.reduce((acc, cur) => acc + (cur.Type === "double" ? 2 : 1), 0);
    if (sumOfBoxes % 3 !== 0) {
      throw new Error('Total size of data grid must be divisible by 3.');
    }
    if (onMobile) {
      for (let i = 0; i < boxes.length - 1; i++) {
        if (boxes[i].Type === 'double' && i > 1) {
          throw new Error('Double box can be only in the first or second place');
        }
        for (let j = i + 1; j < boxes.length; j++) {
          if (boxes[j].Type === "double" && boxes[i].Type !== "double") {
            let temp = boxes[i];
            boxes[i] = boxes[j];
            boxes[j] = temp;
          }
        }
      }
    }
    boxes.forEach((box, i) => {
      items.push(
        <div
          key={i}
          className={`vbn-dg-table-cell ${box.Type}`}
          //role={ADAARIARoles.Group}
          //tabIndex="-1"
          //aria-label={`Data box ${i+1}`}
        >
          <div className="vbn-dg-table-cell-inner">
            <div className="vbn-dg-table-cell--data-box" ref={boxRefs[i]}>
              {
                box.Icon
                &&
                <div className="vbn-dg-table-cell--icon-holder" style={{ backgroundImage: `url("${box.Icon}")` }}>
                  <div className="ada-icon-content">
                    <img className="ada-icon" alt=""/>
                  </div>
                </div>
              }
              <div className="vbn-dg-table-cell--title">
                <AnimatedNumbers text={box.Title} animatedPart={box.AnimatedNumbersInTitle} />
              </div>
              {/*<div className="ada-hidden">:</div>*/}
              <div className="vbn-dg-table-cell--text cont-75">{box.Text}{ box.Tooltip && <InfoTooltip text={box.Tooltip} parentRef={boxRefs[i]} /> }</div>
              {
                box.LearnMore
                &&
                <LearnMoreButton
                  data={box.LearnMore}
                  className="vbn-dg-table-cell--learn-more"
                />
              }
            </div>
            {
              box.Type === "double"
              &&
              <ChartBox data={box.Chart} />
            }
          </div>
        </div>
      );
    });
    let rows = [];
    let rowSum = 0;
    let tempItems = [];
    for (let i = 0; i < items.length; i++) {
      tempItems.push(items[i]);
      rowSum += boxes[i].Type === 'double' ? 2 : 1;
      if (rowSum >= 3) {
        rows.push(<div className="vbn-dg-table-row" key={i}>{[...tempItems]}</div>);
        rowSum = 0;
        tempItems = [];
      }
    }
    return rows;
  };

  return (
    <div
      className="vbn-data-grid"
      ref={theRef}
      aria-label={props.data.Header}
      tabIndex="-1"
    >
      <div className="vbn-dg-wrapper">
        <div className="cpvi-grid-container">
          <div className="vbn-dg-container">
            <div className="vbn-dg-heading" role={ADAARIARoles.Heading}>{props.data.Header}</div>
            <div className="vbn-dg-table">
              {getCells(props.data.Boxes, isMobileLayout)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default DataGrid;
